<script setup>
import { ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { planningApi } from '@/apis/planning.api'
import { usePlanningStore } from '@/stores/planning.store'

const router = useRouter()
const planningStore = usePlanningStore()
const data = ref(null)

onMounted(async () => {
  const res = await planningApi.getPendingApprovalsSummaryAsync()
  data.value = res.data
})

const movementTypeLabel = (v) => {
  const types = planningStore.getLocalizedWarehouseMovementTypes()
  return types.find(i => i.id === v)?.name ?? v
}

const movementTypeColor = (v) => {
  const { warehouseMovementTypeEnum } = planningStore
  if (v === warehouseMovementTypeEnum.LOAD) return 'positive'
  if (v === warehouseMovementTypeEnum.UNLOAD) return 'negative'
  if (v === warehouseMovementTypeEnum.TRANSFER) return 'info'
  return 'grey'
}

const openMovements = () => router.push({ name: 'warehouse-list' })
</script>

<template>
  <div style="padding: 16px 16px 16px; display: flex; flex-direction: column;">
    <div v-if="data === null" style="display:flex; justify-content:center; align-items:center; height:80px;">
      <q-spinner size="md" color="primary" />
    </div>
    <template v-else>
      <div v-if="data.total === 0" class="text-caption text-positive q-mt-xs">
        No pending warehouse movements.
      </div>

      <div v-for="item in data.items" :key="item.id" style="display: flex; align-items: center; gap: 10px; margin-bottom: 10px;">
        <q-avatar size="40px" color="grey-2" style="flex-shrink: 0;">
          <q-img
            v-if="item.service_avatar_file_url || item.service_avatar_url"
            loading="lazy"
            fit="contain"
            :src="item.service_avatar_file_url || item.service_avatar_url"
          />
          <q-icon
            v-else
            name="mdi-camera-outline"
            color="grey-5"
            size="24px"
          />
        </q-avatar>
        <div style="flex: 1; min-width: 0;">
          <div class="text-body2 text-weight-medium ellipsis">{{ item.service_code }} — {{ item.service_name }}</div>
          <div style="display: flex; gap: 4px; flex-wrap: wrap; margin-top: 3px;">
            <q-badge label="Equipment" color="teal" text-color="white" />
            <q-badge :label="movementTypeLabel(item.movement_type)" :color="movementTypeColor(item.movement_type)" text-color="white" />
            <q-badge label="Scheduled" color="orange" text-color="white" />
            <q-badge
              v-if="item.warehouse_name"
              :label="item.warehouse_name"
              color="blue-grey"
              text-color="white"
            />
            <q-badge
              v-if="item.scheduled_at"
              :label="new Date(item.scheduled_at).toLocaleDateString()"
              color="grey-4"
              text-color="grey-8"
            />
          </div>
        </div>
      </div>

      <div v-if="data.total > 0" class="text-caption text-grey-6" style="margin-top: 4px;">
        {{ data.items.length }} out of {{ data.total }} pending approvals shown
      </div>
      <div style="margin-top: 24px;">
        <q-btn
          flat
          no-caps
          padding="4px 8px 4px 0"
          color="primary"
          icon="mdi-package-variant-closed"
          label="Tap Here to Go To Movements"
          @click="openMovements"
        />
      </div>
    </template>
  </div>
</template>
